import React from 'react';

import ExitModal from '../components/common/exit-modal';
import SiteHeader from "../components/layout/site-header";
import SiteFooter from "../components/layout/site-footer";
import CookieConsent from "../components/common/cookie-consent"
import SitewideBanner from "../components/common/promos/sitewide-banner";

import { throttle } from '../helpers/helper-functions';

import 'normalize.css/normalize.css';
import '../styles/global.scss';
import '../styles/shop/snipcart.scss';

class BaseLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stickyHeader: false,
      stickyHeaderFlipped: false,
    };

    this.headerTopRowRef = React.createRef();

    this.handleScroll = this.handleScroll.bind(this);
  }
  
  componentDidMount() {
    this.throttledScroll = throttle(this.handleScroll, 100);
    window.addEventListener('scroll', this.throttledScroll);
  }

  handleScroll() {
    if (window.innerWidth > 960) {
      if (this.headerTopRowRef.current) {
        const topRowHeight = this.headerTopRowRef.current.offsetHeight;

        if (!this.state.stickyHeader && window.pageYOffset > topRowHeight) {
          this.setState({
            stickyHeader: true,
            stickyHeaderFlipped: true,
          });
        } else if (this.state.stickyHeaderFlipped) {
          if (window.pageYOffset === 0) {
            window.scrollTo(0, 1);
          }
          this.setState({
            stickyHeaderFlipped: false,
          });
        } else if (this.state.stickyHeader && window.pageYOffset === 0) {
          this.setState({ stickyHeader: false });
        }
      }
    } else {
      if (window.pageYOffset > 0) {
        if (!this.state.stickyHeader) {
          this.setState({
            stickyHeader: true,
            stickyHeaderFlipped: true,
          });
        }
      } else if (window.pageYOffset === 0) {
        if (this.state.stickyHeader) {
          this.setState({
            stickyHeader: false,
            stickyHeaderFlipped: false,
          });
        }
      }
    }
  }

  render() {
    return (
      <>
        <div className="main-page-wrapper">
          <div className={`paper-wrapper ${(this.state.stickyHeader) ? 'scrolled' : ''}`}>
            <SiteHeader sticky={this.state.stickyHeader} topRowRef={this.headerTopRowRef} homepage={this.props.homepage} />
            {/*<SitewideBanner contents="pdia" path={this.props.path} />*/}
            {this.props.children}
          </div>
        </div>
        <SiteFooter />
        <CookieConsent />
        {!this.props.suppressExitModal && (
          <ExitModal />
        )}
      </>
    );
  }
}

export default BaseLayout;
